import Vue from 'vue'
import i18n from '../i18n'

const getNodeAttributes = (node) => {
  const attrs = {}
  Array.from(node.attributes).forEach(a => { attrs[a.name] = a.value })
  return attrs
}

const getNodeHTML = (node) => {
  const d = document.createElement('div')
  d.appendChild(node)
  return d.innerHTML
}

const traverseNode = (root, baseSelector) => {
  let nodes = []
  const childNodes = root.children

  Array.from(childNodes).map((node, i) => {
    const tagName = node.tagName
    const selector = `${baseSelector} *:nth-child(${i + 1})`

    if (/^H[1-6]$/.test(tagName)) {
      nodes.push({label: node.textContent, type: tagName, selector})
    } else if (['P', 'DIV', 'SPAN'].indexOf(tagName) >= 0) {
      const subTree = traverseNode(node, `${selector} > `)
      if (subTree.length > 0) nodes.push({tree: subTree, type: 'TREE', selector})
    } else if (['IMG', 'VIDEO', 'IFRAME'].indexOf(tagName) >= 0) {
      nodes.push({
        label: i18n.t(`labels.media-types.${tagName.toLowerCase()}`),
        type: tagName,
        selector,
        html: getNodeHTML(node),
        node,
        attributes: getNodeAttributes(node)
      })
    } else if (tagName === 'STRONG' || tagName === 'B') {
      nodes.push({label: node.textContent, type: 'STRONG', selector})
    } else {
      // ignore?
    }
  })
  return nodes
}

const treeParser = (html) => {
  const div = document.createElement('div')
  div.innerHTML = html

  let tree = traverseNode(div, '')
  return tree
}

Vue.prototype.$htmlTree = treeParser

export default {}



// WEBPACK FOOTER //
// ./src/plugins/html-tree.js